import React from 'react';
import { Flex, Text, Image } from '@chakra-ui/react';
import endOfServiceImageSrc from '../static/images/endOfService.webp';

const ServiceEndedPage: React.FC = () => (
  <Flex
    p={6}
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    w="100vw"
    h="100vh"
    sx={{ gap: '24px' }}
  >
    <Image
      src={endOfServiceImageSrc}
      width={142}
      height={143}
      alt="end of service"
    />
    <Text
      textStyle="body2"
      color="graphite.1"
      fontSize={{ base: '1rem', xs: '0.875rem' }}
      lineHeight={{ base: '1.25rem', xs: '1.25rem' }}
      maxW="560px"
      textAlign="center"
    >
      Сервис отзывов больше не работает. Попробуйте оставить отзыв другим
      способом.
    </Text>
  </Flex>
);

export { ServiceEndedPage };
